export const valueDropdownData = [
    //Setup
    {
        endPoint: "apiSetupV2",
        inputFields: [
            {
                type: "String",
                value: "isFrontSystemsWebhook",
                isMandatory: true
            }
        ],
        outputFields: []
    },
    {
        endPoint: "apiUndoSetupV2",
        inputFields: [],
        outputFields: []
    },
    //Stores
    {
        endPoint: "apiValidateStoreV2",
        inputFields: [],
        outputFields: [
            {
                type: "String",
                value: "isStoreName",
                isMandatory: true
            }
        ]
    },
    //Products
    {
        endPoint: "apiGetProductsV2",
        inputFields: [],
        outputFields: []
    },
    {
        endPoint: "apiCheckProductV2",
        inputFields: [],
        outputFields: []
    },
    {
        endPoint: "apiCreateProductV2",
        inputFields: [],
        outputFields: []
    },
    {
        endPoint: "apiUpdateProductV2",
        inputFields: [],
        outputFields: []
    },
    {
        endPoint: "webhookOnMasterDataServerProductUpdateV2",
        inputFields: [],
        outputFields: []
    },
    //Stock
    {
        endPoint: "apiGetStockV2",
        inputFields: [],
        outputFields: [
            { type: "String", value: "isGTIN", isMandatory: true },
            { type: "String", value: "isStock", isMandatory: true }
        ]
    },
    {
        endPoint: "webhookOnPosStockUpdatedV2",
        inputFields: [],
        outputFields: []
    },
    //Prices
    {
        endPoint: "apiGetPricesV2",
        inputFields: [
            {
                type: "String",
                value: "isGTINsArray",
                isMandatory: true
            }
        ],
        outputFields: [
            {
                type: "String",
                value: "isPrice",
                isMandatory: true
            },
            {
                type: "String",
                value: "isItems",
                isMandatory: true
            },
            {
                type: "String",
                value: "isGTIN",
                isMandatory: true
            }
        ]
    },
    {
        endPoint: "webhookOnPosPriceUpdatedV2",
        inputFields: [],
        outputFields: []
    },
    //Shopper Orders / Sales
    {
        endPoint: "apiCheckShopperOrderV2",
        inputFields: [],
        outputFields: []
    },
    {
        endPoint: "apiCreateShopperOrderV2",
        inputFields: [],
        outputFields: []
    },
    {
        endPoint: "apiCreateShopperSaleV2",
        inputFields: [],
        outputFields: []
    },
    {
        endPoint: "webhookOnPosShopperOrderUpdatedV2",
        inputFields: [],
        outputFields: []
    },
    //Supplier Orders
    {
        endPoint: "apiGetSupplierOrderV2",
        inputFields: [],
        outputFields: []
    },
    {
        endPoint: "apiCreateSupplierOrderV2",
        inputFields: [],
        outputFields: []
    }
];

export const typeDropDowndata = [
    { name: "String", value: "String", selected: false },
    {
        name: "Integer",
        value: "Integer",
        selected: false
    },
    {
        name: "Float",
        value: "Float",
        selected: false
    }
];

export const productFields = [
    "ourID",
    "labelBrandID",
    "referenceCode",
    "digitalProductPassport",
    "name",
    "shortDescription",
    "description",
    "productType",
    "category",
    "collectionName",
    "gender",
    "countryOfOrigin",
    "productID",
    "specifications",
    "features",
    "qualityDescription",
    "assortment",
    "assortmentCode",
    "comments",
    "materials",
    "cares",
    "composition",
    "maintenance",
    "factoryOrigin",
    "productionLocations",
    "productionDates",
    "rawMaterialSources",
    "batchOrLotNumber",
    "storageInformation",
    "certificationsAndStandards",
    "laborPractices",
    "carbonFootprint",
    "waterUsage",
    "energyConsumption",
    "waterManagement",
    "chemicalUsage",
    "sustainableSourcing",
    "packaging",
    "environmentalCertifications",
    "tariffCode",
    "otherCustomFields",
    "groupCategoryID",
    "inBOimage",
    "statusEnum"
];

export const gtinFields = [
    "ourID",
    "barcode",
    "labelBrandID",
    "productObjID",
    "sizes",
    "colors",
    "RRP_EUR",
    "RRP_NOK",
    "RRP_DKK",
    "RRP_SEK",
    "RRP_GBP",
    "WSP_EUR",
    "WSP_NOK",
    "WSP_DKK",
    "WSP_SEK",
    "WSP_GBP",
    "size",
    "colorName",
    "colorCodename",
    "colorDescription",
    "colorCode",
    "colorRGB",
    "SKU",
    "netWeight",
    "weightCustomField",
    "weight",
    "images",
    "statusEnum",
    "showForGroups"
];
